import React from 'react';
import * as Lucide from 'lucide-react';
import { resolveCategoryIcon } from '../lib/categoryIcons';

type Props = {
  color: string;
  icon?: string | null;
  size?: number;
  className?: string;
};

/** Pastille couleur + icône blanche (web). */
export default function CategoryIconBadge({
  color,
  icon,
  size = 40,
  className = '',
}: Props) {
  const def = resolveCategoryIcon(icon);
  const IconComp = (Lucide as any)[def.lucide] || Lucide.Tag;
  const glyph = Math.round(size * 0.48);

  return (
    <span
      className={`inline-flex items-center justify-center flex-shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: '9999px',
        backgroundColor: color || '#666',
      }}
      title={def.label}
    >
      <IconComp size={glyph} color="#fff" strokeWidth={2.25} />
    </span>
  );
}
